export default __webpack_public_path__ + "static/GRID22-map-youth-fr-713c3e3705df9f1278792ece5696ff3b.png";